<script>
import StatisticsApi from '@/api/statistics.js'
export default {
  name: 'product',
  data() {
    return {
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      tableData: [],
      paginationObj: {
        totalDataNumber: 0,
        page: 1,
        list_rows: 10,
      },
    }
  },
  props: ['open', 'searchForm'],
  watch: {
    open: function (n, o) {
      if (n != o && n) {
        this.dialogVisible = this.open
        this.getData()
      }
    },
  },
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.dialogVisible = false
      this.$emit('close', {})
    },
    getData() {
      let self = this
      this.loading = true
      StatisticsApi.getProductStatistics(Object.assign(this.searchForm, this.paginationObj))
        .then(res => {
          self.tableData = res.data.list.data
          self.paginationObj.totalDataNumber = res.data.list.total
          self.loading = false
        })
        .catch(error => {})
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.paginationObj.page = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.paginationObj.page = 1;
      this.paginationObj.list_rows = val;
      this.getData();
    },
  },
}
</script>

<template>
  <div>
    <el-dialog title="商品统计" :visible.sync="dialogVisible" width="50%" :before-close="dialogFormVisible">
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" highlight-current-row v-loading="loading">
            <el-table-column prop="product_id" width="100" label="ID"></el-table-column>
            <el-table-column width="70" label="商品图片">
              <template slot-scope="{row}">
                <img :src="row.product.image[0]?row.product.image[0].file_path:''" width="30" height="30" />
              </template>
            </el-table-column>
            <el-table-column prop="product_name" label="商品名称"></el-table-column>
            <!--<el-table-column prop="category.name" width="100" label="商品分类"></el-table-column>-->
            <el-table-column prop="num" width="100" label="购买数量"></el-table-column>
            <!--<el-table-column prop="create_time" width="140" label="添加时间"></el-table-column>-->
            <!--<el-table-column type="selection" :selectable="selectableFunc" width="44" v-if="islist"></el-table-column>-->
            <!--<el-table-column width="80" label="单选" v-if="!islist">-->
            <!--  <template slot-scope="scope">-->
            <!--    <el-button size="mini" v-if="scope.row.noChoose" @click="SingleFunc(scope.row)">选择</el-button>-->
            <!--    <el-button size="mini" v-else disabled>已选</el-button>-->
            <!--  </template>-->
            <!--</el-table-column>-->
          </el-table>
        </div>

        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="paginationObj.page"
            :page-sizes="[2, 10, 20, 50, 100]"
            :page-size="paginationObj.list_rows"
            layout="total, prev, pager, next, jumper"
            :total="paginationObj.totalDataNumber"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/statistics/order/part/product.vue